import moment from "moment";
import React, { FC } from "react";
import { HiEllipsisVertical } from "react-icons/hi2";

import { SettingsDropdown } from "../../../../components/dropdown/SettingsDropdown";
import { Avatar } from "../../../../components/newUI/avatar";
import { Button } from "../../../../components/newUI/button";
import { renderRichText } from "../../utils/parseNote";
import { ContactNoteAction, ContactNoteViewModel } from "./Note.types";
import { noteHeading } from "./noteHeading";

type Props = {
  note: ContactNoteViewModel;
  onView: () => void;
  /** Left out when the person may not edit the note (only its author may, Roadmap 1870). */
  onEdit?: () => void;
  onDelete: () => void;
};

export const NotePreviewRow: FC<Props> = ({
  note,
  onView,
  onEdit,
  onDelete,
}) => {
  const isLongNote = (note.note || "").length > 240;
  const heading = noteHeading(note);
  const actions: ContactNoteAction[] = [
    ...(onEdit ? [{ name: "Edit", action: onEdit }] : []),
    {
      name: "Delete",
      action: onDelete,
      extraClasses: "text-[#DC2626]",
    },
  ];

  return (
    <div
      onClick={onView}
      className={
        "flex cursor-pointer gap-[11px] border-b border-[#F4F5F7] py-3 transition hover:bg-[#FAFAFC]"
      }>
      <Avatar
        id={note.id}
        fullName={note.authorName}
        size={"sm"}
        color={note.authorColor}
        avatarClassNames={"h-[26px] w-[26px] shrink-0 text-[10.5px] font-bold"}
      />
      <div className={"min-w-0 flex-1"}>
        <div className={"flex items-center justify-between gap-2"}>
          <span
            className={
              "min-w-0 break-words text-[13px] font-bold text-[#3A4256]"
            }>
            {note.authorName}
          </span>
          <span className={"shrink-0 text-xs text-[#9097A8]"}>
            {note.createdAt
              ? moment(note.createdAt).format("MMM DD, YYYY")
              : ""}
          </span>
        </div>
        {heading && (
          <div className={"mb-0.5 mt-[3px] text-sm font-bold text-[#1F2433]"}>
            {heading}
          </div>
        )}
        <div
          className={
            "rich-text-content line-clamp-3 min-w-0 max-w-full overflow-hidden break-words text-[13px] leading-[1.5] text-[#5F6577] [&_*]:[overflow-wrap:anywhere] [&_.rich-text-content]:contents"
          }>
          {renderRichText(note.note || "")}
        </div>
        {isLongNote && (
          <div className={"mt-[5px] text-xs font-bold text-[#6B4EFF]"}>
            Read full note
          </div>
        )}
      </div>
      <div
        className={"flex shrink-0 items-start"}
        onClick={(event) => event.stopPropagation()}>
        <SettingsDropdown actionsList={actions}>
          <Button
            type={"button"}
            variant={"outline"}
            size={"sm"}
            iconOnly
            autoWidth
            leftIcon={<HiEllipsisVertical size={18} />}
            className={
              "h-7 w-7 shrink-0 rounded-lg border-[#E4E7EC] p-0 text-[#9097A8] hover:bg-[#F1F2F5]"
            }
          />
        </SettingsDropdown>
      </div>
    </div>
  );
};
